import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=0123e524&scoped=true"
import script from "./DashboardList.vue?vue&type=script&lang=js"
export * from "./DashboardList.vue?vue&type=script&lang=js"
import style0 from "./DashboardList.vue?vue&type=style&index=0&id=0123e524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0123e524",
  null
  
)

export default component.exports